import React, { useState, useContext } from 'react';
import { XSquare } from 'react-feather';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
import { CapabilityName } from '../infrastructure/Constants';
import { CapabilitiesContext } from '../infrastructure/Contexts';
import { Textbox } from '../core/Textbox';

export const SkuInvalidatePopup = ({ popup, onCloseClick }) => {

    const capabilities = useContext(CapabilitiesContext);
    const loader = capabilities.getCapability(CapabilityName.Loader);

    const [orderNumber, setOrderNumber] = useState();
    const [skuNumber, setSkuNumber] = useState();
    const [screenMessage, setScreenMessage] = useState();

    const onInvalidateClick = async () => {
        loader.show();

        var dataAccess = new ApiDataAccess('/api/esko/ui');
        dataAccess.delete(`/order/${orderNumber}/sku/${skuNumber}`)
            .then(response => {
                setScreenMessage(`${orderNumber}-${skuNumber} has been invalidated`);
            })
            .catch(ex => {
                setScreenMessage(`Error during invalidation of ${orderNumber}-${skuNumber}`);
            })
            .finally(() => {
                loader.hide();
            });
    }

    return (
        <div className="skuInvalidatePopup">
            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>Invalidate Sku</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.current.close() }} /></div>
            </div>
            <div className='contentSection'>
                <table>
                    <thead>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Order Number</td>
                            <td>
                                <Textbox required={true} regex={/^[0-9]+$/} onChange={(value, valid) => { setOrderNumber(valid ? value : null) }} value={''} />
                            </td>
                        </tr>
                        <tr>
                            <td>Sku Number</td>
                            <td>
                                <Textbox required={true} regex={/^[0-9]+$/} onChange={(value, valid) => { setSkuNumber(valid ? value : null) }} value={''} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='screenMessage'>
                    {screenMessage}
                </div>  
            </div>
            <div className='footerSection'>
                <button className='btn btn-primary btn-modal' onClick={() => { popup.current.close(); }}>Cancel</button>
                <button className='btn btn-secondary btn-modal' disabled={!orderNumber || !skuNumber} onClick={onInvalidateClick}>Save</button>
            </div>
        </div>
    )
}